module.exports = __webpack_public_path__ + "img/selected4-min.e93dbd77.png";